import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Reality?",
  "description": "",
  "published": "2007-04-24T00:00:00.000Z",
  "redirect_from": ["/blog/reality/swizec/227"],
  "categories": "intrigues, life, linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago I entered a challenge that asks you to take a photo of, preferably, yourself every day for 365 days. So far it's been going on for more than a year but I've only really been doing it for four. And let me just tell you, I'm having a blast. It's anyone's guess right now, but I might eventually incorporate the challenge into this blog.`}</p>
    <p>{`Read an interesting article over at `}<a parentName="p" {...{
        "href": "http://science.slashdot.org/article.pl?sid=07/04/23/231252"
      }}>{`slashdot`}</a>{` today and have to admit I haven't had time to actually read what the article linked to. Whatever all the scientific mumbo jumbo was actually about ... it would appear that physicists have finally found some actual backing for my personal long standing theory that reality is in the eye of the beholder. Now any time somebody calls bollocks on my behaviour I can shove scientific theorems in their face to shut them up.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      